// extracted by mini-css-extract-plugin
export default {"button":"TooltipSection_button__2+1Ft","container":"TooltipSection_container__NOb+N"};